<div
  class="rv-rows small"
  *ngLet="{
    sub: filterChangeHandler | async,
    operatorOptions: operatorOptions | async,
    selectedOperator: selectedOperator | async,
    showDropdown: showDropdown | async,
    options: options | async,
    optionsLoadable: optionsLoadable | async,
    optionsLoader: optionsLoader | async,
    selectedOptionIds: filterIds | async
  } as vm"
>
  <div class="rv-flex flex-fs">
    <riv-icon
      *ngIf="locked"
      [name]="'Lock'"
      [rivTooltip]="lockedHelpText"
    ></riv-icon>
    <select-dropdown
      class="rv-skinny-grow"
      *ngIf="!hideOperators"
      [options]="vm.operatorOptions"
      [selectedOptionId]="vm.selectedOperator"
      (selectedOptionIdChange)="selectedOperatorChange.next($event)"
      [analyticsEvents]="{ select: analyticsEvents.changeFilter }"
      [disabled]="locked"
    ></select-dropdown>
  </div>
  <div class="rv-flex flex-fs">
    <riv-icon
      *ngIf="locked"
      [name]="'Lock'"
      [rivTooltip]="lockedHelpText"
    ></riv-icon>
    <select-dropdown
      class="rv-skinny-grow"
      *ngIf="vm.showDropdown"
      [placeholder]="placeholder"
      [filterable]="optionsFilterable"
      [multiSelect]="true"
      [options]="vm.options"
      [optionsLoader]="vm.optionsLoader"
      [selectedOptionIds]="vm.selectedOptionIds"
      (selectedOptionIdsChange)="selectedOptionIdsChange.next($event)"
      [selectedEnabled]="selectedEnabled"
      [analyticsEvents]="{
        select: analyticsEvents.changeFilter,
        multiSelect: analyticsEvents.changeFilter
      }"
      [disabled]="locked"
    ></select-dropdown>
  </div>
</div>
